import * as Sentry from "@sentry/react";

export const handleError = async (error: Error) => {
  await reportError(error);
};

export const reportError = async (error: any) => {
  try {
    Sentry.captureException(error);
  } catch (err: any) {
    process.env.NODE_ENV === "development" &&
      console.log(`ERROR --> ${err.name} -- ${err.message}`);
  }
};
